export default __webpack_public_path__ + "static/media/FrozenABC2_09.d18849d1.png";